import localforage from "localforage";
import {initialState} from "../redux/reducers";

const mapReduxToLocal = ({
    loggedIn,
    jwt,
}) => ({
    loggedIn,
    jwt,
});

export const connectLocalStorage = new Promise((resolve, reject) => {
    localforage.keys()
        .then((keys) => {
            (keys.includes("redux")
                ? localforage.getItem("redux")
                : localforage.setItem("redux", mapReduxToLocal(initialState))
            )
                .then(resolve)
                .catch(reject);
        })
        .catch(reject);
});

export function subscribeLocalStorage(store) {
    return () => {
        localforage.setItem("redux", mapReduxToLocal(store.getState()));
    };
}


// WEBPACK FOOTER //
// ./src/scripts/connectLocalStorage.js